export const manifest = {
  screens: {
    scr_title: { name: "Title Slide", route: "/", state: {"currentSlide":0}, position: {"x":640.8,"y":348.78} },
    scr_discovery: { name: "Discovery", route: "/", state: {"currentSlide":1}, position: {"x":2040.8,"y":348.78} },
    scr_agenda: { name: "Agenda", route: "/", state: {"currentSlide":2}, position: {"x":3440.8,"y":348.78} },
    scr_bio: { name: "Meet Avy", route: "/", state: {"currentSlide":3}, position: {"x":6188.74,"y":357.37} },
    scr_deal: { name: "The Deal", route: "/", state: {"currentSlide":4}, position: {"x":4910.56,"y":383.13} },
    scr_problem_1: { name: "Holding Brands Back", route: "/", state: {"currentSlide":5}, position: {"x":20240.8,"y":348.78} },
    scr_question: { name: "The Question", route: "/", state: {"currentSlide":6}, position: {"x":11840.8,"y":348.78} },
    scr_is_not: { name: "Brand is NOT", route: "/", state: {"currentSlide":7}, position: {"x":8560,"y":2200} },
    scr_is: { name: "Brand IS", route: "/", state: {"currentSlide":8}, position: {"x":9960,"y":2200} },
    scr_problem_2: { name: "Weak Branding Cost", route: "/", state: {"currentSlide":9}, position: {"x":21640.8,"y":348.78} },
    scr_exercise: { name: "Exercise", route: "/", state: {"currentSlide":10}, position: {"x":9040.8,"y":348.78} },
    scr_credibility: { name: "Credibility", route: "/", state: {"currentSlide":11}, position: {"x":14640.8,"y":348.78} },
    scr_realization: { name: "Realization", route: "/", state: {"currentSlide":12}, position: {"x":16040.8,"y":348.78} },
    scr_decision: { name: "Decision", route: "/", state: {"currentSlide":13}, position: {"x":17440.8,"y":348.78} },
    scr_proof: { name: "Client Proof", route: "/", state: {"currentSlide":14}, position: {"x":18840.8,"y":348.78} },
    scr_definition: { name: "Definition Intro", route: "/", state: {"currentSlide":15}, position: {"x":160,"y":2200} },
    scr_pret: { name: "Pret Example", route: "/", state: {"currentSlide":16}, position: {"x":1560,"y":2200} },
    scr_cd6al5: { name: "Pret Details", route: "/", state: {"currentSlide":17}, position: {"x":11360,"y":2200} },
    scr_case_intro: { name: "Case Study Intro", route: "/", state: {"currentSlide":18}, position: {"x":160,"y":4180} },
    scr_hvac_prob: { name: "HVAC Problem", route: "/", state: {"currentSlide":19}, position: {"x":1560,"y":4180} },
    scr_hvac_fix: { name: "HVAC Fix", route: "/", state: {"currentSlide":20}, position: {"x":2960,"y":4180} },
    scr_hvac_res: { name: "HVAC Result", route: "/", state: {"currentSlide":21}, position: {"x":4360,"y":4180} },
    scr_global_case: { name: "Global Case Study", route: "/", state: {"currentSlide":22}, position: {"x":5760,"y":4180} },
    scr_revenue: { name: "Revenue Chain", route: "/", state: {"currentSlide":23}, position: {"x":160,"y":6160} },
    scr_framework: { name: "AVY Framework", route: "/", state: {"currentSlide":24}, position: {"x":5760,"y":2200} },
    scr_align: { name: "Align Deep Dive", route: "/", state: {"currentSlide":25}, position: {"x":7160,"y":2200} },
    scr_wrapup: { name: "Wrap Up", route: "/", state: {"currentSlide":26}, position: {"x":1560,"y":6160} },
    scr_summary: { name: "Summary Table", route: "/", state: {"currentSlide":27}, position: {"x":2960,"y":6160} },
  },
  sections: {
    sec_fitiwt: { name: "Presentation Sequence", x: 480.8, y: 128.78, width: 39320, height: 1180 },
    sec_mkjm1j: { name: "Definition & Framework", x: 0, y: 1980, width: 12720, height: 1180 },
    sec_enm5t2: { name: "Case Studies", x: 0, y: 3960, width: 8520, height: 1180 },
    sec_cslr41: { name: "Closing & Summary", x: 0, y: 5940, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_fitiwt", children: [
      { kind: "screen", id: "scr_title" },
      { kind: "screen", id: "scr_discovery" },
      { kind: "screen", id: "scr_agenda" },
      { kind: "screen", id: "scr_bio" },
      { kind: "screen", id: "scr_deal" },
      { kind: "screen", id: "scr_exercise" },
      { kind: "screen", id: "scr_question" },
      { kind: "screen", id: "scr_credibility" },
      { kind: "screen", id: "scr_realization" },
      { kind: "screen", id: "scr_decision" },
      { kind: "screen", id: "scr_proof" },
      { kind: "screen", id: "scr_problem_1" },
      { kind: "screen", id: "scr_problem_2" },
    ] },
    { kind: "section", id: "sec_mkjm1j", children: [
      { kind: "screen", id: "scr_definition" },
      { kind: "screen", id: "scr_pret" },
      { kind: "screen", id: "scr_framework" },
      { kind: "screen", id: "scr_align" },
      { kind: "screen", id: "scr_is_not" },
      { kind: "screen", id: "scr_is" },
      { kind: "screen", id: "scr_cd6al5" },
    ] },
    { kind: "section", id: "sec_enm5t2", children: [
      { kind: "screen", id: "scr_case_intro" },
      { kind: "screen", id: "scr_hvac_prob" },
      { kind: "screen", id: "scr_hvac_fix" },
      { kind: "screen", id: "scr_hvac_res" },
      { kind: "screen", id: "scr_global_case" },
    ] },
    { kind: "section", id: "sec_cslr41", children: [
      { kind: "screen", id: "scr_revenue" },
      { kind: "screen", id: "scr_wrapup" },
      { kind: "screen", id: "scr_summary" },
    ] },
  ],
}
